import { Spinner } from "@digipost/dds-spinner-react";
import { FC, PropsWithChildren } from "react";

import styles from "./SpinnerContainer.module.less";

const SpinnerContainer: FC<PropsWithChildren> = ({ children }) => (
  <div className={styles.spinnerContainer}>
    <Spinner size={"large"} aria-busy={"true"} />
    {children}
  </div>
);

export default SpinnerContainer;
